import { render, staticRenderFns } from "./GoogleLogin.vue?vue&type=template&id=d47ad33a&scoped=true"
import script from "./GoogleLogin.vue?vue&type=script&lang=js"
export * from "./GoogleLogin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d47ad33a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/kemingchen/Projects/VisionFutureWeb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d47ad33a')) {
      api.createRecord('d47ad33a', component.options)
    } else {
      api.reload('d47ad33a', component.options)
    }
    module.hot.accept("./GoogleLogin.vue?vue&type=template&id=d47ad33a&scoped=true", function () {
      api.rerender('d47ad33a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Auth/GoogleLogin.vue"
export default component.exports